export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('/Users/hail/work/base/apps/contents/src/pages/index.vue'),
    children: [
      {
        path: ':databaseId',
        name: 'database',
        component: () => import('/Users/hail/work/base/apps/contents/src/pages/index/[databaseId].vue'),
        children: [
          {
            path: ':tableId',
            name: '//[databaseId]/[tableId]',
            component: () => import('/Users/hail/work/base/apps/contents/src/pages/index/[databaseId]/[tableId].vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "layout": "sidenav"
    }
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/Users/hail/work/base/apps/contents/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/Users/hail/work/base/apps/contents/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/oauth-callback',
    name: '/oauth-callback',
    component: () => import('/Users/hail/work/base/apps/contents/src/pages/oauth-callback.vue'),
    /* no children */
  },
  {
    path: '/row',
    name: '/row',
    component: () => import('/Users/hail/work/base/apps/contents/src/pages/row.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

